import { infoFetchGetUsuariosI, makeUsuario } from "dtos/usuarios";
import { ENDPOINTS } from "./endpoints";
import { getResponseWithPagination } from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const getUsuarios = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetUsuariosI>
  >({
    method: "GET",
    uri: ENDPOINTS.USERS + "/all",
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeUsuario(ctElemento),
  );
  return {
    page: response.page,
    cantidad: response.cantidad,
    elementos: elementosFormated,
  };
};

export const postUsuario = async (params: any) => {
  const response = await sendRequest({
    method: "POST",
    uri: ENDPOINTS.USERS,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return response;
};

export const deleteUsuario = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.USERS + "/" + id,
  });

  return response;
};

export const editarUsuario = async (body: any) => {
  const response = await sendRequest({
    method: "PUT",
    uri: ENDPOINTS.USERS,
    params: body,
  });

  return response;
};
